import React,{useState,useEffect} from "react";
import Icons from "../../../Components/Icons/Icons";
import Modal from "react-bootstrap/Modal";
import { roundOffTwoDecimal } from "../../../Utils/CommonFunctions";

const FileMapping = (props) => {
	const {filesList,isModalOpen,toggleFiles,filesValueHandler,filesInternal,isLoader} = props;
	const [selectedFiles,setSelectedFiles] = useState([]);

	useEffect(() => {
		// Initialize selected files when modal opens
		if(isModalOpen) {
			// Pre-select files that are already in filesInternal
			const existingFileIds = (filesInternal || []).map(file => file.id);
			setSelectedFiles(existingFileIds);
		}
	}, [isModalOpen, filesInternal]);

	// Don't filter out files that are already in filesInternal
	// Instead, show all files and pre-select the ones in filesInternal
	const getFilteredFilesList = () => {
		if(!filesList || filesList.length === 0) return [];
		return filesList;
	};

	const filteredFiles = getFilteredFilesList();

	const handleCheckboxChange = (fileId, isChecked) => {
		if(isChecked) {
			setSelectedFiles([...selectedFiles, fileId]);
		} else {
			setSelectedFiles(selectedFiles.filter(id => id !== fileId));
		}
	};

	const saveValueHandler = () => {
		const {filesValueHandler} = props;
		
		// Get IDs of files already in filesInternal
		const existingFileIds = (filesInternal || []).map(file => file.id);
		
		// Get selected file objects from filesList, excluding ones already in filesInternal
		const selectedFileObjects = filteredFiles.filter(file => 
			selectedFiles.includes(file.id) && !existingFileIds.includes(file.id)
		);
		
		// Transform to match filesInternal structure
		const filesToAdd = selectedFileObjects.map(fileItem => ({
			id: fileItem.id,
			value: fileItem.id,
			checked: null,
			file: fileItem,
			label: fileItem.name || fileItem.label || 'Unknown',
			size: fileItem.size || 0
		}));
		
		filesValueHandler(filesToAdd);
		setSelectedFiles([]);
	};

	return(
		<Modal dialogClassName="modal-dialog modal-dialog modal-xl height-auto" show={isModalOpen} onHide={toggleFiles} backdrop="static" keyboard={false} >
              <Modal.Header>
                <h5 className="modal-title secondary_color pl-2 mb-0"> Select Files </h5> 
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="card card-transparent">
                      <div className="card-header p-0">
                        <div className="card-title">
                          Choose Files
                        </div>
                      </div>
                      <div className="card-body" style={{maxHeight: '350px', overflow: 'auto'}}>
                        {
							isLoader ? <div class="text-center fw-bold" >...Loading </div> :
						
						(filteredFiles.length > 0 ? (
                        	<ul className="list-group">
                        		{filteredFiles.map((file, index) => {
                        			const isChecked = selectedFiles.includes(file.id);
                        			const fileSize = file.size ? roundOffTwoDecimal(file.size / 1000) + ' KB' : 'Unknown size';
                        			const fileName = file.name || file.label || file.id;
                        			
                        			return (
                        				<li key={file.id || index} className="roles_Setup list-group-item p-2 d-flex align-items-center">
                        					{/* <span className="mr-2">
                        						<Icons iconType="Attachments" />
                        					</span> */}
                        					<label className="form-check-label d-flex align-items-center" style={{width: '100%'}}>
                        						<input 
                        							checked={isChecked} 
                        							onChange={e => handleCheckboxChange(file.id, e.target.checked)} 
                        							className="form-check-input mr-2" 
                        							type="checkbox" 
                        							value={file.id} 
                        						/> 
                        						<span className="form-check-sign ml-2">{fileName}</span>
                        						<span className="ml-auto text-muted">{fileSize}</span>
                        					</label>
                        				</li>
                        			);
                        		})}
                        	</ul>
                        ) : (
                        	<div className="text-center p-4">
                        		<p className="text-muted">No files available </p>
                        	</div>
                        )) }
                      </div>
                    </div>
                  </div>
                </div>   
              </Modal.Body>
              <Modal.Footer>
                  <a className="btn btn-border border-default mr-2" data-dismiss="modal" onClick={toggleFiles}> Cancel </a>                 
                  <a className="btn primary_bg" onClick={saveValueHandler} disabled={selectedFiles.length === 0}>Save</a>                                                    
              </Modal.Footer>
            </Modal>
	)
}

export default FileMapping;

